import { create } from 'zustand';

export type ModalStoreState = {
  isOpen: boolean;
};

export type ModalStoreActions<T> = {
  close: () => void;
  closeWithoutReset: () => void;
  open: (customData?: T) => void;
  toggle: () => void;
};

export const createModalStore = <T>(initialData?: T, isOpen = false) =>
  create<ModalStoreActions<T> & ModalStoreState & T>((set) => ({
    ...(initialData || ({} as T)),
    close: () =>
      set((state) => {
        return {
          ...state,
          ...initialData,
          isOpen: false,
        };
      }),
    closeWithoutReset: () =>
      set((state) => {
        return {
          ...state,
          isOpen: false,
        };
      }),
    isOpen,
    open: (customData?: T) =>
      set((state) => {
        if (customData) {
          return {
            ...state,
            ...customData,
            isOpen: true,
          };
        }

        return { ...state, isOpen: true };
      }),
    toggle: () => set((state) => ({ ...state, isOpen: !state.isOpen })),
  }));
